export const changeoutTurnReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_OUT_TURN":
        return action.payload.outTurn;
      default:
        return state;
    }
  };
  